import swal from "@sweetalert/with-react";
import React from "react";
import { toast } from "react-toastify";
import ToastView, { defaultToastProps } from "../../components/newcomponents/ToastView";
import ContnetAlertComp from "../newCreateContent/ContentAlertComp";
let greyBtnCls = "create-close-btn";
let blueBtnCls = "stay-text";
const error = "error";
const showSwalCreateContent = (
   titleText,
   contentText,
   callback = () => {},
   showClose = false,
   boldText = "",
   contentText2 = "",
   buttons = [
      {
         className: `${greyBtnCls}`,
         text: "Close",
         id: "alert-cancel-button",
      },
      { className: blueBtnCls, text: "Stay", id: "alert-confirm-button" },
   ]
) => {
   return swal(
      <ContnetAlertComp
         showClose={showClose}
         titleText={titleText}
         contentText={contentText}
         boldText={boldText}
         contentText2={contentText2}
         from="content"
         onClose={(btnData) => {
            swal.close();
            if (btnData.id === "alert-cancel-button") {
               callback();
            }
         }}
         onAction={(btnData) => {
            swal.close();
         }}
         buttons={buttons}
      />,
      { buttons: false }
   );
};

const ShowAlert = (text, type) => toast(<ToastView text={text} type={type} />, defaultToastProps);
export { ShowAlert, error, showSwalCreateContent };
